var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeofences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 33.3332C29.1547 33.3332 33.3334 29.1545 33.3334 23.9998C33.3334 18.8452 29.1547 14.6665 24.0001 14.6665C18.8454 14.6665 14.6667 18.8452 14.6667 23.9998C14.6667 29.1545 18.8454 33.3332 24.0001 33.3332Z",
    stroke: "#1B2559",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28C26.2091 28 28 26.2091 28 24C28 21.7909 26.2091 20 24 20C21.7909 20 20 21.7909 20 24C20 26.2091 21.7909 28 24 28Z",
    stroke: "#1B2559",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 25.3332C24.7365 25.3332 25.3334 24.7362 25.3334 23.9998C25.3334 23.2635 24.7365 22.6665 24.0001 22.6665C23.2637 22.6665 22.6667 23.2635 22.6667 23.9998C22.6667 24.7362 23.2637 25.3332 24.0001 25.3332Z",
    fill: "#1B2559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofences);
export default __webpack_public_path__ + "static/media/Geofences.79a223c3dbe19aa3edc47601bdf9f8a9.svg";
export { ForwardRef as ReactComponent };